// ** React Imports
import { useContext } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Components
import LinkNative from "components/layout/LinkNative";
import Text from "components/typography/Text";
import Block from "components/layout/Block";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const AboutUs = ({ quote, link, linkName, data, author }) => {
	const { isPhone } = useContext(deviceTypeContext);

	const isDarkMode = useSelector(
		(state) => state.globalCommon?.darkMode?.isDarkMode
	);

	// #####################################################

	return (
		<Block pt={isPhone ? 10 : 0} pb={3} px={10}>
			<Block>
				<Text italicFontStyle size="1.15rem" bold>
					&quot;{quote}&quot;
				</Text>
			</Block>
			<Block>
				<LinkNative
					href={link}
					color={isDarkMode ? "primaryLight" : "primary"}
					target="_blank"
					underline
				>
					{linkName}
				</LinkNative>
			</Block>
			<Block>
				<Text color="grey">{data}</Text>
			</Block>
			<Block textRight bold size="1.5rem">
				{author}
			</Block>
		</Block>
	);
};

export default AboutUs;
